<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    title="选择线边库"
    width="800px"
    top="8vh"
  >
    <TableSelect :filter="filter" ref="tableSelect" :columns="columns" module="basic" url="warehouses/kingdee" @select="warehouseSelect">
      <template slot="adSearch">
        <el-form :inline="true" ref="form" :model="filter">
          <el-form-item label="仓库编号" prop="warehouseNo">
            <el-input v-model.trim="filter.warehouseNo" placeholder="请输入仓库编号" clearable />
          </el-form-item>
          <el-form-item label="仓库名称" prop="warehouseName">
            <el-input v-model.trim="filter.warehouseName" placeholder="请输入仓库名称" clearable />
          </el-form-item>
        </el-form>
      </template>
    </TableSelect>
  </el-dialog>
</template>

<script>
import TableSelect from "@/components/TableSelect.vue";

export default {
  components: { TableSelect },
  data() {
    return {
      dialogVisible: false,
      filter: {
        warehouseNo: "",
        warehouseName: "",
      },
      columns: [
        {
          title: "仓库编号",
          key: "warehouseNo",
          width: 100,
          align: "center",
        },
        {
          title: "仓库名称",
          key: "warehouseName",
          minWidth: 150,
        },
        {
          title: "操作",
          slot: "action",
          width: 80,
          align: "center",
        },
      ],
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.$refs.tableSelect.loadData();
      });
    },

    warehouseSelect(row) {
      this.dialogVisible = false;
      this.$emit("select", row);
    },
  },
};
</script>
